// NOTE: @kien-kreate: this module is experimental. Use with care.

import { ResourceKey } from "kreate-server/types";
import { unstable_serialize } from "swr";

export type FallbackField<T> = {
  resourceKey: ResourceKey | undefined;
  result: T | undefined;
};

export type FallbackObject = Record<string, FallbackField<unknown>>;

export function formatFallbackObject(fallbackObject: FallbackObject) {
  const result: Record<string, unknown> = {};
  for (const field of Object.values(fallbackObject)) {
    if (field.result == null || field.resourceKey == null) continue;
    result[unstable_serialize(field.resourceKey)] = field.result;
  }
  return result;
}
